/**
 * useRetentionGeo - общий выбор гео для раздела «Ретеншен»
 * ==========================================================
 *
 * Гео здесь — параметр РАЗДЕЛА, а не глобальный фильтр сайдбара: остальные
 * дашборды страну нигде не показывают, и молчаливое применение выбора ко всему
 * приложению давало бы неверные выводы.
 *
 * Выбор один на все три вкладки ретеншена (когорты / кривая / N-й день) и
 * переживает перезагрузку страницы, поэтому живёт в localStorage, а не в
 * состоянии виджета: переключение вкладки не должно сбрасывать страну.
 *
 * Значение — массив ISO-кодов ('US', 'DE'); пустой массив = все страны.
 * storageKey — свой ключ для виджета вне ретеншена, чтобы выборы не смешивались.
 */

import { useCallback, useMemo } from 'react';
import { useLocalStorage } from './useLocalStorage';

const STORAGE_KEY = 'retention:geo';

export function useRetentionGeo(storageKey = STORAGE_KEY) {
  const [stored, setStored] = useLocalStorage(storageKey, []);

  const geos = useMemo(() => {
    const list = Array.isArray(stored) ? stored : [];
    return list
      .map((value) => String(value).trim().toUpperCase())
      .filter((value) => /^[A-Z]{2}$/.test(value));
  }, [stored]);

  // Строковый ключ для массива зависимостей useWidgetData: сам массив
  // пересоздаётся на каждый рендер и дёргал бы перезапрос вечно.
  const geoKey = geos.join(',');

  const toggleGeo = useCallback(
    (geo) => {
      const code = String(geo || '').trim().toUpperCase();
      if (!/^[A-Z]{2}$/.test(code)) return;

      setStored((prev) => {
        const list = Array.isArray(prev) ? prev : [];
        return list.includes(code) ? list.filter((item) => item !== code) : [...list, code];
      });
    },
    [setStored]
  );

  const clearGeos = useCallback(() => setStored([]), [setStored]);

  return { geos, geoKey, toggleGeo, clearGeos };
}

export default useRetentionGeo;
